/**
 * API Configuration for Mobile App
 * Centralized configuration for all API endpoints
 */

import { Platform } from 'react-native';

// Detect if running on web platform
const isWeb = Platform.OS === 'web';

// Get API URLs from environment variables
const API_BASE_URL =
  process.env['EXPO_PUBLIC_API_URL'] || 'http://192.168.0.196:4000/api/v1';
const WEB_API_URL =
  process.env['EXPO_PUBLIC_WEB_API_URL'] || 'http://localhost:3000';

// For React Native Web, use the same origin as the web app
const getWebApiUrl = () => {
  if (isWeb && typeof window !== 'undefined') {
    // Use the same origin as the current page
    return window.location.origin;
  }
  return WEB_API_URL;
};

export const apiConfig = {
  // Backend API (Python/FastAPI)
  backend: {
    baseUrl: API_BASE_URL,
    endpoints: {
      auth: `${API_BASE_URL}/auth`,
      users: `${API_BASE_URL}/users`,
      recipes: `${API_BASE_URL}/recipes`,
      equipment: `${API_BASE_URL}/equipment`,
      creators: `${API_BASE_URL}/creators`,
      notifications: `${API_BASE_URL}/notifications`,
    },
  },

  // Web API (Next.js)
  web: {
    baseUrl: getWebApiUrl(),
    endpoints: {
      abTest: `${getWebApiUrl()}/api/dashboard/ab-test`,
      analytics: `${getWebApiUrl()}/api/analytics`,
      dashboard: `${getWebApiUrl()}/api/dashboard`,
    },
  },
} as const;

// Helper function to get A/B test endpoint
export const getABTestEndpoint = (userId: string) =>
  `${apiConfig.web.endpoints.abTest}/${userId}`;

// Helper function to get analytics endpoint
export const getAnalyticsEndpoint = (path: string) =>
  `${apiConfig.web.endpoints.analytics}/${path}`;

export default apiConfig;
